import { Fragment } from 'react'
import { useFormContext } from 'react-hook-form'
import { useCalculatedAmounts } from 'src/hooks/useCalculatedAmounts'
import { InvoiceFormInputs } from '../InvoiceEditForm'

type Props = {
  page: number
}
export const InvoiceItems: React.FC<Props> = ({ page }) => {
  const { watch } = useFormContext<InvoiceFormInputs>()
  const { calculated_amount } = useCalculatedAmounts(
    watch('items'),
    watch('taxSettings')
  )
  const items = watch('items')
  // 請求書の商品数でページ送りがある
  const baseYPosition = page === 1 ? 233 : 60
  const itemsInPage = page === 1 ? items.slice(0, 16) : items.slice(16, 30)
  return itemsInPage.length > 0 ? (
    <>
      {/* デフォルトで表示しておく空欄の4行 */}
      {items.length < 16 &&
        [...Array(4)].map((_, i) => (
          <line
            key={i}
            x1="36"
            y1={baseYPosition + 47.5 + i * 24}
            x2="464"
            y2={baseYPosition + 47.5 + i * 24}
            stroke="#EAEAEA"
          />
        ))}

      <rect
        x="36"
        y={baseYPosition}
        width="428"
        height={
          (Math.max(itemsInPage.length, items.length < 16 ? 4 : 0) + 1) * 24 -
          0.5
        }
        stroke="#EAEAEA"
      />
      {itemsInPage.map((v, i) => {
        const y = 24 * i + baseYPosition + 40
        return (
          <Fragment key={i}>
            <line
              x1="36"
              y1={baseYPosition + 47.5 + i * 24}
              x2="464"
              y2={baseYPosition + 47.5 + i * 24}
              stroke="#EAEAEA"
            />
            <text
              x="45"
              y={y}
              fill="#0D0D0D"
              fontSize={'10px'}
              fontWeight={'bold'}
            >
              {v.name}
            </text>
            <text
              x="290"
              y={y}
              fill="#0D0D0D"
              fontSize={'10px'}
              textAnchor="end"
            >
              {v.quantity || 0}
              {v.unit}
            </text>
            <text
              x="370"
              y={y}
              fill="#0D0D0D"
              fontSize={'10px'}
              textAnchor="end"
            >
              ¥{(v.unit_price || 0).toLocaleString()}
            </text>
            {calculated_amount.invoice_items && (
              <text
                x="450"
                y={y}
                fill="#0D0D0D"
                fontSize={'10px'}
                textAnchor="end"
              >
                ¥
                {calculated_amount.invoice_items[i]?.amount?.toLocaleString() ||
                  0}
              </text>
            )}
          </Fragment>
        )
      })}

      {/* ヘッダー部分 */}

      <rect width="428" height="24" x="36" y={baseYPosition} fill="#0D0D0D" />

      <line
        x1="264.5"
        y1={baseYPosition}
        x2="264.5"
        y2={baseYPosition + 24}
        stroke="#6C6C6C"
      />

      <line
        x1="304.5"
        y1={baseYPosition}
        x2="304.5"
        y2={baseYPosition + 24}
        stroke="#6C6C6C"
      />
      <line
        x1="384.5"
        y1={baseYPosition}
        x2="384.5"
        y2={baseYPosition + 24}
        stroke="#6C6C6C"
      />
      <text
        x="140"
        y={baseYPosition + 16}
        fontSize="10px"
        fill="white"
        fontWeight="bold"
      >
        品目
      </text>
      <text
        x="275"
        y={baseYPosition + 16}
        fontSize="10px"
        fill="white"
        fontWeight="bold"
      >
        数量
      </text>
      <text
        x="335"
        y={baseYPosition + 16}
        fontSize="10px"
        fill="white"
        fontWeight="bold"
      >
        単価
      </text>
      <text
        x="415"
        y={baseYPosition + 16}
        fontSize="10px"
        fill="white"
        fontWeight="bold"
      >
        金額
      </text>
    </>
  ) : null
}
